import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { IntToBetragText } from "../Helper/ZahlenFormat";

// Definieren Sie Ihre Stile
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: 25,
    position: "relative",
    //paddingLeft:45,
    paddingBottom: 55, // Platz für den footer unten
    //fontFamily:"Helvetica",
  },
  footer: {
    position: "absolute",
    bottom: -35, // Position für den footer +Oben -Unten
    left: 0,
    right: 0,
    textAlign: "center",
    //backgroundColor: "#fee", // zum Testen
  },
  pageNumber: { bottom: 13 }, // Position für die pageNumber - abhängig von der Schriftgröße  10 -> 13
  content: {
    // backgroundColor: "#ffe", // zum Testen
  },
  line: {
    margin: 1,
    padding: 1,
    borderBottom: 1,
    borderBottomColor: "#000",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    backgroundColor: "#fdd",
    height: "30%",
  },
  absatz: {
    width: "100%",
    flexGrow: 1,
  },

  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    backgroundColor: "#fdd",
    //borderRadius:12,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    //height:'50%',
  },
  tableRow: {
    //margin: 'auto',
    margin: 0,
    width: "100%",
    flexDirection: "row",
    backgroundColor: "#dfd",
    borderLeftWidth: 1,
    borderLeftColor: "#000",
    //borderRadius:10,
  },
  tableCell: {
    //margin: 'auto',
    margin: 0,
    width: "33.33333333%",
    //marginTop: 5,
    fontSize: 10,
    padding: 15,
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ddf",
    //borderRadius:3,
  },
  tableHeader: {
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
  },

  headlines: {
    fontSize: 16,
    fontWeight: "bold",
    fontStyle: "italic",
  },

  diagonalText45: {
    position: "absolute",
    top: "35%",
    left: "25%",
    transform: "rotate(-45deg)", // Diagonal um 45 Grad
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.2)", // Halbtransparente schwarze Farbe
    fontSize: 60,
  },
  diagonalText45a: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-45deg)", // Diagonal um 45 Grad
    textAlign: "center",
    color: "#fff",
    fontSize: 120,
  },
  sekrechtText: {
    position: "absolute",
    top: "50%",
    left: "-30px",
    transform: "translate(-50%, -50%) rotate(-90deg)",
    textAlign: "center",
    fontSize: 10,
    color: "#aaa",
  },
});

const TEXT_ALIGN = ["left", "center", "right"];
const Line = () => <View style={styles.line}></View>;

const Headlines = ({ texte }) => (
  <>
    <View fixed={true} style={[styles.headlines]}>
      <Line />
      <ViewDatenausgabe
        texte={texte}
        fontSize={16}
        fontWeight={"bold"}
        aligns={[TEXT_ALIGN[0], TEXT_ALIGN[1], TEXT_ALIGN[2]]}
      />
      <Line />
    </View>
  </>
);
const Footerlines = ({ texte, fontSize = 10 }) => {
  return (
    <>
      <View fixed={true} style={styles.footer}>
        <Line />
        <ViewDatenausgabe
          texte={texte}
          aligns={[TEXT_ALIGN[0], TEXT_ALIGN[1], TEXT_ALIGN[2]]}
        />
        <Text
          style={[styles.pageNumber, { bottom: 13, fontSize: fontSize }]}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
      </View>
    </>
  );
};

const ViewDatenausgabe = ({
  texte,
  widths,
  aligns = [0],
  fontSize = 10,
  nachkommas = [],
  marginLeft = 0,
  marginRight = 0,
  paddingLeft = 5,
  paddingRight = 5,
  paddingTop = 2,
  paddingBottom = 2,
  evenRowBackground = "",
  oddRowBackground = "",
  borderColor = "",
  fixed = false,
  fixedHead = false,
  fixedHeadLine = false,
  fontWeight = "",
  endeLinie = false,
}) => {
  const autoAlign = aligns.length === 0;
  texte.map((item, itemIndex) => {
    while (aligns.length < item.length) {
      aligns.push("auto"); // Erkennen links für Text rechts für Zahl
    }
    while (nachkommas.length < item.length) {
      nachkommas.push(nachkommas[0]);
    }
  });
  return (
    <View fixed={fixed}>
      {texte.map((item, itemIndex) => (
        <View
          fixed={fixedHead && itemIndex === 0} // Zeile
          key={itemIndex}
          style={{
            flexDirection: "row",
            justifyContent: widths === undefined ? "flex-start" : "",
            marginLeft: marginLeft,
            marginRight: marginRight,
            fontSize: fontSize,
            fontWeight: fontWeight,
            borderStyle: "solid",
            borderWidth:
              borderColor !== "" || (fixedHeadLine && itemIndex === 0) ? 1 : 0,
            borderLeftWidth: 0,
            borderTopWidth: 0,
            borderRightWidth: 0,
            borderBottomColor: borderColor,
            backgroundColor:
              fixedHeadLine && itemIndex === 0
                ? ""
                : itemIndex % 2 === 0
                ? oddRowBackground
                : evenRowBackground,

            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
          }}
        >
          {item.map((text, textIndex) => (
            <Text
              key={textIndex}
              style={{
                marginLeft:2,
                marginRight:2,
                textAlign:
                  aligns[textIndex] !== "auto"
                    ? aligns[textIndex]
                    : typeof text !== "number" || isNaN(text)
                    ? TEXT_ALIGN[0]
                    : TEXT_ALIGN[2],

                width:
                  widths === undefined
                    ? `${100 / aligns.length}%`
                    : `${widths[textIndex]}%`,
              }}
            >
              {typeof text !== "number" || isNaN(text)
                ? text
                //: text.toFixed(nachkommas[textIndex])}
                :IntToBetragText(text,nachkommas[textIndex])}
            </Text>
          ))}
        </View>
      ))}
      {endeLinie && <Line />}
    </View>
  );
};

export const PdfProfiGenerator = ({ pdfProfidaten, handlePennding }) => {
  const Pending = () => {
    if (handlePennding) handlePennding(false);
    return null;
  };
  if (handlePennding) handlePennding(true);
  const PdfHead = pdfProfidaten.PdfHead;
  const PdfHeadDatenArray = pdfProfidaten.PdfHeadDatenArray;
  const PdfDatenArray = pdfProfidaten.PdfDatenArray;
  const PdfFooterText = pdfProfidaten.PdfFooterText;
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={true}>
        <View>
          <View style={styles.content}>
            <Headlines texte={[PdfHead.text]} />
            {PdfHeadDatenArray.map((PdfHeadText, index) => (
              <ViewDatenausgabe
                key={index}
                fixed={PdfHeadText.fixed}
                borderColor={PdfHeadText.borderColor}
                texte={PdfHeadText.texte}
                widths={PdfHeadText.widths}
                aligns={PdfHeadText.aligns}
                fontSize={PdfHeadText.fontSize}
              />
            ))}
            {PdfDatenArray.map((PdfDatenzeilen, index) => ( 
              <ViewDatenausgabe
                key={index}
                nachkommas={PdfDatenzeilen.nachkommas}
                aligns={PdfDatenzeilen.aligns}
                fixedHead={PdfDatenzeilen.fixedHead}
                fixedHeadLine={PdfDatenzeilen.fixedHeadLine}
                oddRowBackground={PdfDatenzeilen.oddRowBackground}
                evenRowBackground={PdfDatenzeilen.evenRowBackground}
                fontSize={PdfDatenzeilen.fontSize}
                widths={PdfDatenzeilen.widths}
                texte={PdfDatenzeilen.texte}
                endeLinie={PdfDatenzeilen.endeLinie}
              />
            ))}
          </View>

          <Footerlines
            texte={[[PdfFooterText.textLink, "", PdfFooterText.textRechts]]}
          />
          <View style={styles.sekrechtText}>
            <Text>Powered by Ing. Christian Pohanka</Text>
          </View>
          <View style={styles.diagonalText45}>
            <Text>piu-printex</Text>
          </View>
        </View>
      </Page>
      <Pending />
    </Document>
  );
};

export const getPdfProfidatenTest = (z1 = 120, z2 = 15, z3 = 10) => {
  const PdfHead = {
    text: ["Musterliste", "1.5.2024", "PDF Generator"],
  };
  const PdfHeadText = {
    fixed: true,
    texte: [
      [" - hier beginnt ein fixer Bereich unter dem Kopf!"],
      ["Links 1", "Mitte 1", "Rechts 1"],
      ["Links 2", "Mitte 2", "Rechts 2"],
      ["Links 3", "Mitte 3", "Rechts 3"],
      ["Immer auf der Seite unterhalb vom Kopf"],
      [" "],
    ],
    //widths: [20, 20, 50],
    aligns: ["left", "center", "right"],
  };
  const PdfFooterText = {
    textLink: "Powered by Aconsoft",
    textRechts: "Ing.Christian Pohanka",
  };

  const geerateZufallsDaten = (anzahl) => {
    const PdfDatenzeilen = {
      texte: [],
      nachkommas: [0, 0, 0, 2, 2, 2, 2, 0],
      aligns: [
        "left",
        "left",
        "left",
        "right",
        "right",
        "right",
        "right",
        "right",
      ],
      fixedHead: true,
      fixedHeadLine: true,
      oddRowBackground: "#EEE",
      fontSize: 11,
    };
    PdfDatenzeilen.texte.push([
      "nr",
      "Text A",
      "Text B",
      "Zahl 1",
      "Zahl 2",
      "Zahl 3",
      "Zahl 4",
      "Zahl 5",
    ]);

    for (let i = 0; i < anzahl; i++) {
      const text1 = `A-Text ${Math.floor(Math.random() * 100)}`;
      const text2 = `B-Text ${Math.floor(Math.random() * 100)}`;
      const numbers = Array.from({ length: 5 }, () =>
        Math.floor(Math.random() * 10001)
      );

      PdfDatenzeilen.texte.push([
        i + 1,
        text1,
        text2,
        numbers[0] / 100,
        numbers[1] / 100,
        numbers[2] / 100,
        numbers[3] / 100,
        numbers[4],
      ]);
    }
    return PdfDatenzeilen;
  };
  const PdfDatenArray = [];
  PdfDatenArray.push(geerateZufallsDaten(z1));
  PdfDatenArray.push(geerateZufallsDaten(z2));
  PdfDatenArray.push(geerateZufallsDaten(z3));
  const PdfHeadDatenArray = [];
  PdfHeadDatenArray.push(PdfHeadText);

  const pdfProfidaten = {
    HomeLink: ["Home", "/"],
    PdfHead: PdfHead,
    PdfHeadDatenArray: PdfHeadDatenArray,
    PdfDatenArray: PdfDatenArray,
    PdfFooterText: PdfFooterText,
  };
  return pdfProfidaten;
};

export const PdfTest = () => {
  return <PdfProfiGenerator pdfProfidaten={getPdfProfidatenTest()} />;
  /*
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={true}>
        <View>
          <View style={styles.content}>
            <Headlines texte={[PdfHead.text]} />
            {PdfHeadDatenArray.map((PdfHeadText, index) => (
              <ViewDatenausgabe
                key={index}
                fixed={PdfHeadText.fixed}
                borderColor={PdfHeadText.borderColor}
                texte={PdfHeadText.texte}
                widths={PdfHeadText.widths}
                aligns={PdfHeadText.aligns}
                fontSize={PdfHeadText.fontSize}
              />
            ))}
            {PdfDatenArray.map((PdfDatenzeilen, index) => (
              <ViewDatenausgabe
                key={index}
                nachkommas={PdfDatenzeilen.nachkommas}
                aligns={PdfDatenzeilen.aligns}
                fixedHead={PdfDatenzeilen.fixedHead}
                fixedHeadLine={PdfDatenzeilen.fixedHeadLine}
                oddRowBackground={PdfDatenzeilen.oddRowBackground}
                evenRowBackground={PdfDatenzeilen.evenRowBackground}
                fontSize={PdfDatenzeilen.fontSize}
                texte={PdfDatenzeilen.texte}
              />
            ))}
          </View>

          <Footerlines
            texte={[[PdfFooterText.textLink, "", PdfFooterText.textRechts]]}
          />
        </View>
      </Page>
    </Document>
  );
  */
};
/*



<View style={[styles.table]}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCell, styles.tableHeader]}>
                  <Text>Header 1</Text>
                </View>
                <View style={[styles.tableCell, styles.tableHeader]}>
                  <Text>Header 2</Text>
                </View>
                <View style={[styles.tableCell, styles.tableHeader]}>
                  <Text>Header 3</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCell}>
                  <Text>Data 1</Text>
                  <Line />
                </View>
                <View style={styles.tableCell}>
                  <Text>Data 2</Text>
                  <Line />
                </View>
                <View style={styles.tableCell}>
                  <Text>Data 3</Text>
                  <Line />
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableCell}>
                  <Text>Data 4</Text>
                </View>
                <View style={styles.tableCell}>
                  <Text>Data 5</Text>
                </View>
                <View style={styles.tableCell}>
                  <Text>Data 6</Text>
                </View>
              </View>
            </View>




             <Page size="A4" style={styles.page}>
        <View style={styles.absatz}>
        <View style={styles.section}>
          <Text>Hello, world! 1/1</Text>
          <Line />
        </View>
        <View style={styles.section}>
          <Text>Hello, world! 2/1</Text>
          <Line />
          <Line />
        </View>
        <View style={styles.section}>
          <Text>Hello, world! 3/1</Text>
          <Line />
          <Line />
          <Line />
        </View>
        <View style={styles.line} />
      </View>

      <View style={styles.absatz}>
        <View style={styles.section}>
          <Text>Section #1 1/2</Text>
          <Line />
        </View>
        <View style={styles.section}>
          <Text>Section #2 2/2</Text>
          <Line />
          <Line />
        </View>
      </View>

*/
export const PdfSourceInfo=[{head:"PDF Daten für kurzen Daten - Source Muster",
code:`pdfDaten = {
  HomeLink: ["PdfTestHome", "/PdfTestHome"],
  PdfHead: {
    fixed: true,
    text: ["PDF Generator", "Profimode", "1.5.2024"],
  },
  PdfHeadDatenArray: [
    { texte: [["Willkommen in der wirklichen Welt"]] },
  ],
  PdfDatenArray: [{ texte: [["A", "B", "C"], ["X", "Y"], ["Z"]] }],
  PdfFooterText: {
    textLink: "Powered by Aconsoft",
    textRechts: "Ing.Christian Pohanka",
  },`},{head:"PDF Daten Übergabe - Source",
code:`pdfProfidaten.PdfHead
pdfProfidaten.PdfHeadDatenArray
pdfProfidaten.PdfDatenArray
pdfProfidaten.PdfFooterText
`},
{head:"PdfHead - Eigenschaften der Kopfdaten",code:
`{
text: ["Text links", "Text mittig", "Text rechts"], // -> fix mit zwei Striche in 16
}`},
{head:"PdfHeadDatenArray[PdfHeadText, ] - Eigenschaften der Textblöcke unter den Kopfdaten",code:
`{
PdfHeadText.fixed:true, // -> auf jeder Seite ausgeben
PdfHeadText.borderColor:"#00F",  // -> 
PdfHeadText.texte:[["",""],["",""]],  // -> 
PdfHeadText.widths:[40,60],  // -> Breite in Prozent
PdfHeadText.aligns:["left","right"]  // -> je Spalte
PdfHeadText.fontSize:11,  // -> Schriftgröße
}`},


{head:"PdfDatenArray[PdfDatenzeilen, ] - Eigenschaften der Datenblöcke",code:
`{
PdfDatenzeilen.nachkommas:[0,0,2] // -> je Spalte
PdfDatenzeilen.aligns:["left","right","center"]  // -> je Spalte
PdfDatenzeilen.fixedHead:true, //-> erste Zeile als Überschrift
PdfDatenzeilen.fixedHeadLine:true, //-> Linie unter der ersten Zeile
PdfDatenzeilen.oddRowBackground:"#EEE", // -> Zeilenfinder der ungeraden Zeilen
PdfDatenzeilen.evenRowBackground:"",// -> Zeilenfinder der geraden Zeilen
PdfDatenzeilen.fontSize:11,  // -> Schriftgröße
PdfDatenzeilen.widths:[40,60],  // -> Breite in Prozent
PdfDatenzeilen.texte:[["",""],["",""]],  // -> Daten der Spalten und Zeilen string/number
PdfDatenzeilen.endeLinie:true, //-> Linie nach den Daten
}`},


{head:"Footerlines - Eigenschaften der Fusszeile",code:
`{
texte=[[PdfFooterText.textLink, "", PdfFooterText.textRechts]], // -> automatsch Seitenzahl in der Mitte und Linie davor
}`},


];